/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxValidationMessageComponent } from './validation-message/validation-message.component';
import {
  NgxFilterByNumberComponent,
} from './custom-smart-table-components/filter-by-number/filter-by-number.component';
import { QuestionHeaderComponent } from './question-header/question-header.component';
import { NbActionsModule, NbButtonModule, NbCardModule, NbInputModule, NbTabsetModule, NbUserModule, NbRadioModule, NbSelectModule, NbListModule, NbIconModule, NbSpinnerModule, NbDatepickerModule, NbCheckboxModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../@theme/theme.module';
import { UploadFileDialogComponent } from './upload-file-dialog/upload-file-dialog.component';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { ViewAttachmentComponent } from './view-attachment/view-attachment.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer'; 


const COMPONENTS = [
  NgxValidationMessageComponent,
  NgxFilterByNumberComponent,
  QuestionHeaderComponent,
  UploadFileDialogComponent,
  ViewAttachmentComponent
];


const NB_MODULES = [
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbInputModule,


  NbIconModule,

  NbCheckboxModule,
  PdfJsViewerModule,

];
@NgModule({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NbEvaIconsModule,
    ...NB_MODULES
  ],
  exports: [...COMPONENTS],
  declarations: [...COMPONENTS, ],
  entryComponents: [
    NgxFilterByNumberComponent,
  ],
})
export class ComponentsModule {
}
